import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=6cb5f5e9&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Payroll.vue"
export default component.exports